




























































































































































































import Vue from "vue";
import PerfectScrollbar from "perfect-scrollbar";

export default Vue.extend({
  props: {
    css: {
      type: Object,
      required: true
    }
  },
  mounted() {
    const code_wrappers: HTMLElement[] = Array.from(
      document.querySelectorAll(".code_wrapper")
    );
    code_wrappers.forEach(element => {
      const ps = new PerfectScrollbar(element);
    });
  },
  computed: {
    get_javascript_title(): string {
      if (this.css.is_vanilla) {
        return "JavaScript";
      } else {
        return "jQuery";
      }
    }
  },
  methods: {
    copy_clipboard(e: string): void {
      const copy_target = document.querySelector<HTMLElement>(e);
      if (copy_target == null) {
        return;
      }
      (document.getSelection() as Selection).selectAllChildren(copy_target);
      document.execCommand("copy");
      //document.getSelection().empty();
    }
  }
});
